

// import React, { useState } from "react";
// import {
//   Box, Grid, Card, Typography, TextField, Button,
//   Checkbox, FormControlLabel, IconButton, InputAdornment,
//   CircularProgress, useMediaQuery, useTheme
// } from "@mui/material";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import ayujalogo from "../../Logos/AuthScreens/AuthLogo.png";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Footer from "../../Common/Footer";
// import { fetchUserFromRedis } from "./Register";
// import CustomDialog from "../../../CustomDialog";

// const Login = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));    // < 600px
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("md")); // < 900px (mobile + tablet)

//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({ identifier: "", password: "" });
//   const [loading, setLoading] = useState(false);
//   const [user, setUser] = useState(null);

//   const loginAPI = process.env.REACT_APP_LOGIN_API;

//   const [dialog, setDialog] = useState({
//     open: false,
//     title: "",
//     message: "",
//     type: "info",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleGoogleLogin = () => {
//     window.location.href = process.env.REACT_APP_GOOGLE_REDIRECT_API;
//   };

  // const handleLogin = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await axios.post(loginAPI, formData);
  //     const userId = res.data.user.user_id;
  //     const token = res.data.token;
  //     const userRole = res.data.user.role;
  //     const approvalStatus = res.data.user.approval_status;
  //     const isApproved = res.data.user.is_approved;

  //     if (approvalStatus === "pending" || !isApproved) {
  //       setDialog({ open: true, title: "Account Pending Approval", message: "Your account is awaiting admin approval. You will be notified once approved.", type: "warning" });
  //       setLoading(false);
  //       return;
  //     }
  //     if (approvalStatus === "rejected") {
  //       setDialog({ open: true, title: "Account Not Approved", message: "Your registration was Rejected. Please contact support for more information.", type: "error" });
  //       setLoading(false);
  //       return;
  //     }
  //     if (approvalStatus !== "approved") {
  //       setDialog({ open: true, title: "Account Access Denied", message: "Your account status is invalid. Please contact support.", type: "error" });
  //       setLoading(false);
  //       return;
  //     }

  //     sessionStorage.setItem("token", token);
  //     sessionStorage.setItem("userId", userId);

  //     if (userRole === "admin" || userRole === "superadmin") {
  //       setDialog({ open: true, title: "Access Denied", message: "Admins cannot use this resident app.", type: "error" });
  //       setLoading(false);
  //       return;
  //     }

  //     try {
  //       const userData = await fetchUserFromRedis(userId, token);
  //       setUser(userData);
  //     } catch (redisErr) {
  //       console.warn("Could not fetch user from Redis:", redisErr);
  //     }

  //     setDialog({ open: true, title: "Login Successful", message: "Welcome back!", type: "success" });

  //     setTimeout(() => {
  //       if (userRole === "resident") navigate("/services");
  //       else navigate("/");
  //     }, 1500);

  //   } catch (err) {
  //     console.error("Login error:", err);
  //     if (err.response?.status === 403) {
  //       const errorData = err.response.data;
  //       const status = errorData.status;
  //       if (status === "pending_approval") {
  //         setDialog({ open: true, title: "Account Pending Approval", message: errorData.error || "Your account is awaiting admin approval.", type: "warning" });
  //       } else if (status === "rejected") {
  //         setDialog({ open: true, title: "Account Not Approved", message: errorData.error || "Your registration was not approved.", type: "error" });
  //       } else {
  //         setDialog({ open: true, title: "Access Denied", message: errorData.error || "You do not have permission to access this application.", type: "error" });
  //       }
  //     } else if (err.response?.status === 401) {
  //       setDialog({ open: true, title: "Login Failed", message: "Invalid email/phone or password. Please try again.", type: "error" });
  //     } else if (err.response?.status === 404) {
  //       setDialog({ open: true, title: "User Not Found", message: "No account found with this email or phone number.", type: "error" });
  //     } else {
  //       setDialog({ open: true, title: "Login Failed", message: err.response?.data?.message || "An error occurred. Please try again.", type: "error" });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           minHeight: "80vh",
//           p: { xs: 2, sm: 3, md: 4 },
//           backgroundColor: "#fff",
//         }}
//       >
//         <Card
//           sx={{
//             borderRadius: "16px",
//             maxWidth: { xs: "100%", sm: "520px", md: "960px" },
//             mx: "auto",
//             width: "100%",
//             overflow: "hidden",
//             boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <Grid container sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}>

//             {/* ── LEFT SECTION ── */}
//             <Grid
//               item
//               xs={12}
//               md={6}
//               sx={{
//                 background: "linear-gradient(135deg, #004f54, #007a85, #007a85)",
//                 color: "white",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 p: { xs: 3, sm: 3, md: 4 },
//                 flex: { md: "0 0 50%" },
//                 maxWidth: { md: "50%" },
//               }}
//             >
//               {/* Logo */}
//               <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 1, md: 2 } }}>
//                 <img
//                   src={ayujalogo}
//                   alt="Ayuja Logo"
//                   style={{
//                     height: isMobile ? "56px" : isTablet ? "64px" : "80px",
//                     width: "auto",
//                     display: "block",
//                   }}
//                 />
//               </Box>

//               {/* Welcome Text */}
//               <Typography
//                 variant={isMobile ? "h6" : "h4"}
//                 sx={{ fontWeight: "bold", mb: { xs: 0.5, md: 2 }, textAlign: "center" }}
//               >
//                 {isMobile ? "Welcome Back to Ayuja" : "Welcome \nBack to Ayuja"}
//               </Typography>

//               {/* Tagline — hide on mobile to keep it compact */}
//               {!isMobile && (
//                 <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
//                   Your trusted partner in personalized in-home care for every stage of life
//                 </Typography>
//               )}

//               {/* Feature pills */}
//               <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: { xs: 2, md: 3 }, mb: { xs: 1.5, md: 4 }, flexWrap: "wrap" }}>
//                 <Typography variant="body2">✅ 24/7 Support</Typography>
//                 <Typography variant="body2">✅ Certified Caregivers</Typography>
//               </Box>

//               {/* Emergency Support Box — compact on mobile, full on desktop */}
//               {!isMobile && (
//                 <Box
//                   sx={{
//                     backgroundColor: "rgba(255, 255, 255, 0.1)",
//                     borderRadius: "12px",
//                     p: { xs: 2, md: 3 },
//                     textAlign: "center",
//                     width: { sm: "80%", md: "70%" },
//                   }}
//                 >
//                   <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//                     Emergency Support Available
//                   </Typography>
//                   <Typography variant="body2" sx={{ mb: 2 }}>
//                     Need immediate assistance? Our emergency support team is available 24/7 to help you and your loved ones.
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     onClick={() => navigate("/contactus")}
//                     sx={{
//                       backgroundColor: "#80ED99",
//                       "&:hover": { backgroundColor: "#6dda86" },
//                       color: "#22577A",
//                       textTransform: "none",
//                       borderRadius: "8px",
//                     }}
//                   >
//                     Contact Emergency
//                   </Button>
//                 </Box>
//               )}

//               {/* Mobile-only: compact emergency CTA */}
//               {isMobile && (
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   onClick={() => navigate("/contactus")}
//                   sx={{
//                     borderColor: "#80ED99",
//                     color: "#80ED99",
//                     textTransform: "none",
//                     borderRadius: "8px",
//                     fontSize: "12px",
//                   }}
//                 >
//                   🚨 Contact Emergency
//                 </Button>
//               )}
//             </Grid>

//             {/* ── RIGHT SECTION: Sign In Form ── */}
//             <Grid
//               item
//               xs={12}
//               md={6}
//               sx={{
//                 backgroundColor: "white",
//                 p: { xs: 3, sm: 4, md: 4 },
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 flex: { md: "0 0 50%" },
//                 maxWidth: { md: "50%" },
//               }}
//             >
//               <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" mb={0.5}>
//                 Sign In
//               </Typography>
//               <Typography variant="body2" mb={2} color="text.secondary">
//                 Access your personalized care dashboard
//               </Typography>

//               <TextField
//                 label="Email or Phone"
//                 name="identifier"
//                 value={formData.identifier}
//                 onChange={handleChange}
//                 placeholder="Enter email or 10-digit phone"
//                 fullWidth
//                 margin="normal"
//                 size={isMobile ? "small" : "medium"}
//               />

//               <TextField
//                 label="Password"
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 placeholder="Enter your password"
//                 type={showPassword ? "text" : "password"}
//                 fullWidth
//                 margin="normal"
//                 size={isMobile ? "small" : "medium"}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)} size="small">
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                   flexWrap: "wrap",
//                   gap: 0.5,
//                 }}
//               >
//                 <FormControlLabel
//                   control={<Checkbox size="small" />}
//                   label={<Typography variant="body2">Remember me</Typography>}
//                 />
//                 <Button
//                   variant="text"
//                   size="small"
//                   sx={{ textTransform: "none", fontSize: "13px" }}
//                   onClick={() => navigate("/ForgotPassword")}
//                 >
//                   Forgot Password?
//                 </Button>
//               </Box>

//               <Button
//                 variant="contained"
//                 fullWidth
//                 sx={{
//                   backgroundColor: "#007a85",
//                   "&:hover": { backgroundColor: "#005f64" },
//                   mb: 2,
//                   py: isMobile ? 1 : 1.4,
//                   fontSize: isMobile ? "14px" : "15px",
//                 }}
//                 onClick={handleLogin}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={22} color="inherit" /> : "Sign In"}
//               </Button>

//               <Typography textAlign="center" variant="body2">
//                 Don't have an account?{" "}
//                 <a href="/Register" style={{ color: "#007a85", fontWeight: "bold" }}>
//                   Sign Up
//                 </a>
//               </Typography>
//             </Grid>
//           </Grid>
//         </Card>

//         <CustomDialog
//           open={dialog.open}
//           title={dialog.title}
//           message={dialog.message}
//           type={dialog.type}
//           onClose={() => setDialog({ ...dialog, open: false })}
//         />
//       </Box>

//       <Footer />
//     </>
//   );
// };

// export default Login;










































import React, { useState, useRef, useEffect } from "react";
import {
  Box, Grid, Card, Typography, TextField, Button,
  Checkbox, FormControlLabel, IconButton, InputAdornment,
  CircularProgress, useMediaQuery, useTheme, ToggleButtonGroup,
  ToggleButton, Alert, Collapse
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import ayujalogo from "../../Logos/AuthScreens/AuthLogo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../../Common/Footer";
import { fetchUserFromRedis } from "./Register";
import CustomDialog from "../../../CustomDialog";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// ─── OTP digit input ──────────────────────────────────────────────────────────
const OtpInput = ({ value, onChange, disabled }) => {
  const digits = value.split("").concat(Array(6).fill("")).slice(0, 6);
  const refs = useRef([]);

  const handleKey = (e, idx) => {
    if (e.key === "Backspace" && !digits[idx] && idx > 0) {
      refs.current[idx - 1].focus();
    }
  };

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/\D/g, "").slice(-1);
    const next = [...digits];
    next[idx] = val;
    onChange(next.join(""));
    if (val && idx < 5) refs.current[idx + 1].focus();
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    onChange(pasted);
    refs.current[Math.min(pasted.length, 5)]?.focus();
    e.preventDefault();
  };

  return (
    <Box sx={{ display: "flex", gap: 1, justifyContent: "center", my: 2 }}>
      {digits.map((d, i) => (
        <TextField
          key={i}
          inputRef={(el) => (refs.current[i] = el)}
          value={d}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKey(e, i)}
          onPaste={i === 0 ? handlePaste : undefined}
          disabled={disabled}
          inputProps={{
            maxLength: 1,
            style: { textAlign: "center", fontSize: "22px", fontWeight: "bold", padding: "10px 0" },
          }}
          sx={{
            width: 44,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              "&.Mui-focused fieldset": { borderColor: "#007a85", borderWidth: 2 },
            },
          }}
        />
      ))}
    </Box>
  );
};

// ─── Countdown timer ──────────────────────────────────────────────────────────
const useCountdown = (seconds) => {
  const [remaining, setRemaining] = useState(0);
  const start = () => setRemaining(seconds);
  useEffect(() => {
    if (remaining <= 0) return;
    const t = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(t);
  }, [remaining]);
  return [remaining, start];
};

// ═════════════════════════════════════════════════════════════════════════════
const Login = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [user, setUser] = useState(null);
  const [loginMode, setLoginMode] = useState("password");

  // Password state
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ identifier: "", password: "" });

  // OTP state
  const [otpIdentifier, setOtpIdentifier] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpChannel, setOtpChannel] = useState("");
  const [otp, setOtp] = useState("");
  const [countdown, startCountdown] = useCountdown(60);

  // Shared
  const [loading, setLoading] = useState(false);
  const [inlineError, setInlineError] = useState("");
  const loginAPI = process.env.REACT_APP_LOGIN_API;
  const [dialog, setDialog] = useState({ open: false, title: "", message: "", type: "info" });

  const showDialog = (title, message, type) =>
    setDialog({ open: true, title, message, type });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // ── Mode switch ───────────────────────────────────────────────────────────
  const switchMode = (_, val) => {
    if (!val) return;
    setLoginMode(val);
    setInlineError("");
    setOtpSent(false);
    setOtp("");
  };

  // ── Shared post-login handler ─────────────────────────────────────────────
  const finishLogin = (res) => {
    const { user_id, role, approval_status, is_approved } = res.data.user;
    const token = res.data.token;

    if (approval_status === "pending" || !is_approved) {
      showDialog("Account Pending Approval", "Your account is awaiting admin approval.", "warning");
      return;
    }
    if (approval_status === "rejected") {
      showDialog("Account Not Approved", "Your registration was rejected. Contact support.", "error");
      return;
    }
    if (role === "admin" || role === "superadmin") {
      showDialog("Access Denied", "Admins cannot use this resident app.", "error");
      return;
    }

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("userId", user_id);
    fetchUserFromRedis(user_id, token).catch(() => {});
    showDialog("Login Successful", "Welcome back!", "success");
    setTimeout(() => navigate(role === "resident" ? "/services" : "/",{replace: true}), 1500);
  };


  // ── Password login ────────────────────────────────────────────────────────
  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await axios.post(loginAPI, formData);
      const userId = res.data.user.user_id;
      const token = res.data.token;
      const userRole = res.data.user.role;
      const approvalStatus = res.data.user.approval_status;
      const isApproved = res.data.user.is_approved;

      if (approvalStatus === "pending" || !isApproved) {
        setDialog({ open: true, title: "Account Pending Approval", message: "Your account is awaiting admin approval. You will be notified once approved.", type: "warning" });
        setLoading(false);
        return;
      }
      if (approvalStatus === "rejected") {
        setDialog({ open: true, title: "Account Not Approved", message: "Your registration was Rejected. Please contact support for more information.", type: "error" });
        setLoading(false);
        return;
      }
      if (approvalStatus !== "approved") {
        setDialog({ open: true, title: "Account Access Denied", message: "Your account status is invalid. Please contact support.", type: "error" });
        setLoading(false);
        return;
      }

      if (userRole !== "resident") {
        setDialog({
          open: true,
          title: "Access Denied",
          message: "This app is only for residents. Please use the appropriate portal to sign in.",
          type: "error"
        });
        setLoading(false);
        return;
      }

      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userId", userId);

      if (userRole === "admin" || userRole === "superadmin") {
        setDialog({ open: true, title: "Access Denied", message: "Admins cannot use this resident app.", type: "error" });
        setLoading(false);
        return;
      }

      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData);
      } catch (redisErr) {
        console.warn("Could not fetch user from Redis:", redisErr);
      }

      setDialog({ open: true, title: "Login Successful", message: "Welcome back!", type: "success" });

      setTimeout(() => {
        if (userRole === "resident") navigate("/services",{replace: true});
        else navigate("/");
      }, 1500);

    } catch (err) {
      console.error("Login error:", err);
      if (err.response?.status === 403) {
        const errorData = err.response.data;
        const status = errorData.status;
        if (status === "pending_approval") {
          setDialog({ open: true, title: "Account Pending Approval", message: errorData.error || "Your account is awaiting admin approval.", type: "warning" });
        } else if (status === "rejected") {
          setDialog({ open: true, title: "Account Not Approved", message: errorData.error || "Your registration was not approved.", type: "error" });
        } else {
          setDialog({ open: true, title: "Access Denied", message: errorData.error || "You do not have permission to access this application.", type: "error" });
        }
      } else if (err.response?.status === 401) {
        setDialog({ open: true, title: "Login Failed", message: "Invalid email/phone or password. Please try again.", type: "error" });
      } else if (err.response?.status === 404) {
        setDialog({ open: true, title: "User Not Found", message: "No account found with this email or phone number.", type: "error" });
      } else {
        setDialog({ open: true, title: "Login Failed", message: err.response?.data?.message || "An error occurred. Please try again.", type: "error" });
      }
    } finally {
      setLoading(false);
    }
  };

  // ── OTP: send ─────────────────────────────────────────────────────────────
  const handleSendOtp = async () => {
    setInlineError("");
    if (!otpIdentifier.trim()) {
      setInlineError("Please enter your email or phone number.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/send-login-otp`, {
        identifier: otpIdentifier.trim(),
      });

      if (res.data.success) {
        setOtpSent(true);
        setOtpChannel(res.data.channel);
        startCountdown();
      } else {
        const status = res.data.status;
        if (status === "pending_approval") {
          showDialog(
            "Account Pending Approval",
            "Your account is awaiting admin approval. Once approved, you can log in using OTP or password.",
            "warning"
          );
        } else if (status === "rejected") {
          showDialog(
            "Account Not Approved",
            "Your registration was not approved. Please contact support.",
            "error"
          );
        } else if (status === "non_resident") {
          showDialog(
            "Use Password Login",
            "login is only available for residents.",
            "info"
          );
          switchMode(null, "password");
        } else if (status === "access_denied") {
          showDialog(
            "Account Access Restricted",
            "Your account access is restricted. Please contact support.",
            "error"
          );
        } else {
          setInlineError(res.data.message || "Failed to send OTP.");
        }
      }
} catch (err) {
  const data = err.response?.data || {};
  const status = data.status;
  const message = data.message;

  if (status === "pending_approval") {
    showDialog(
      "Account Pending Approval",
      message || "Your account is awaiting admin approval. Once approved, you can log in.",
      "warning"
    );
  } else if (status === "rejected") {
    showDialog(
      "Account Not Approved",
      message || "Your registration was not approved. Please contact support.",
      "error"
    );
  } else if (status === "non_resident") {
    showDialog(
      "Use Password Login",
      message || "Login is only available for residents.",
      "info"
    );
    switchMode(null, "password");
  } else if (status === "access_denied") {
    showDialog(
      "Account Access Restricted",
      message || "Your account access is restricted. Please contact support.",
      "error"
    );
  } else {
    setInlineError(message || "Failed to send OTP. Try again.");
  }
} finally {
      setLoading(false);
    }
  };

  // ── OTP: resend ───────────────────────────────────────────────────────────
  const handleResendOtp = async () => {
    setOtp("");
    setInlineError("");
    await handleSendOtp();
  };

  // ── OTP: verify ───────────────────────────────────────────────────────────
  const handleVerifyOtp = async () => {
    setInlineError("");
    if (otp.length < 6) {
      setInlineError("Please enter the complete 6-digit OTP.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/verify-login-otp`, {
        identifier: otpIdentifier.trim(),
        otp,
      });
      finishLogin({ data: res.data });
    } catch (err) {
      const msg = err.response?.data?.message || "Invalid OTP. Please try again.";
      setInlineError(msg);
      if (err.response?.status === 429) {
        setOtpSent(false);
        setOtp("");
      }
    } finally {
      setLoading(false);
    }
  };

  // ════════════════════════════════════════════════════════════════════════════
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          p: { xs: 2, sm: 3, md: 4 },
          backgroundColor: "#fff",
        }}
      >
        <Card
          sx={{
            borderRadius: "16px",
            maxWidth: { xs: "100%", sm: "520px", md: "960px" },
            mx: "auto",
            width: "100%",
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid container sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}>

            {/* ── LEFT PANEL ────────────────────────────────────────────── */}
            <Grid
              item xs={12} md={6}
              sx={{
                background: "linear-gradient(135deg, #004f54, #007a85)",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                p: { xs: 3, sm: 3, md: 4 },
                flex: { md: "0 0 50%" },
                maxWidth: { md: "50%" },
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 1, md: 2 } }}>
                <img
                  src={ayujalogo}
                  alt="Ayuja Logo"
                  style={{ height: isMobile ? "56px" : isTablet ? "64px" : "80px", width: "auto" }}
                />
              </Box>

              <Typography
                variant={isMobile ? "h6" : "h4"}
                sx={{ fontWeight: "bold", mb: { xs: 0.5, md: 2 }, textAlign: "center" }}
              >
                {isMobile ? "Welcome Back to Ayuja" : "Welcome\nBack to Ayuja"}
              </Typography>

              {!isMobile && (
                <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                  Your trusted partner in personalized in-home care for every stage of life
                </Typography>
              )}

              <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 2, md: 3 }, mb: { xs: 1.5, md: 4 }, flexWrap: "wrap" }}>
                <Typography variant="body2">✅ 24/7 Support</Typography>
                <Typography variant="body2">✅ Certified Caregivers</Typography>
              </Box>

              {!isMobile && (
                <Box sx={{ backgroundColor: "rgba(255,255,255,0.1)", borderRadius: "12px", p: { xs: 2, md: 3 }, textAlign: "center", width: { sm: "80%", md: "70%" } }}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                    Emergency Support Available
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    Our emergency support team is available 24/7 to help you and your loved ones.
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => navigate("/contactus")}
                    sx={{ backgroundColor: "#80ED99", "&:hover": { backgroundColor: "#6dda86" }, color: "#22577A", textTransform: "none", borderRadius: "8px" }}
                  >
                    Contact Emergency
                  </Button>
                </Box>
              )}

              {isMobile && (
                <Button
                  variant="outlined" size="small"
                  onClick={() => navigate("/contactus")}
                  sx={{ borderColor: "#80ED99", color: "#80ED99", textTransform: "none", borderRadius: "8px", fontSize: "12px" }}
                >
                  🚨 Contact Emergency
                </Button>
              )}
            </Grid>

            {/* ── RIGHT PANEL ───────────────────────────────────────────── */}
            <Grid
              item xs={12} md={6}
              sx={{
                backgroundColor: "white",
                p: { xs: 3, sm: 4, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flex: { md: "0 0 50%" },
                maxWidth: { md: "50%" },
              }}
            >
              <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" mb={0.5}>
                Sign In
              </Typography>
              <Typography variant="body2" mb={2} color="text.secondary">
                Access your personalized care dashboard
              </Typography>

              {/* ── Mode toggle ── */}
              <ToggleButtonGroup
                value={loginMode}
                exclusive
                onChange={switchMode}
                fullWidth
                size="small"
                sx={{ mb: 2.5 }}
              >
                <ToggleButton
                  value="password"
                  sx={{
                    textTransform: "none", fontWeight: 600, gap: 0.5,
                    "&.Mui-selected": { backgroundColor: "#007a85", color: "#fff", "&:hover": { backgroundColor: "#005f64" } },
                  }}
                >
                  <LockOutlinedIcon fontSize="small" /> Password
                </ToggleButton>
                <ToggleButton
                  value="otp"
                  sx={{
                    textTransform: "none", fontWeight: 600, gap: 0.5,
                    "&.Mui-selected": { backgroundColor: "#007a85", color: "#fff", "&:hover": { backgroundColor: "#005f64" } },
                  }}
                >
                  <PhoneAndroidOutlinedIcon fontSize="small" /> OTP
                </ToggleButton>
              </ToggleButtonGroup>

              {/* ── Inline error ── */}
              <Collapse in={!!inlineError}>
                <Alert severity="error" sx={{ mb: 2, borderRadius: "8px" }} onClose={() => setInlineError("")}>
                  {inlineError}
                </Alert>
              </Collapse>

              {/* ══════════ PASSWORD MODE ══════════ */}
              {loginMode === "password" && (
                <>
                  <TextField
                    label="Email or Phone"
                    name="identifier"
                    value={formData.identifier}
                    onChange={handleChange}
                    placeholder="Enter email or 10-digit phone"
                    fullWidth margin="normal"
                    size={isMobile ? "small" : "medium"}
                  />
                  <TextField
                    label="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    type={showPassword ? "text" : "password"}
                    fullWidth margin="normal"
                    size={isMobile ? "small" : "medium"}
                    onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} size="small">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 0.5 }}>
                    <FormControlLabel
                      control={<Checkbox size="small" />}
                      label={<Typography variant="body2">Remember me</Typography>}
                    />
                    <Button variant="text" size="small" sx={{ textTransform: "none", fontSize: "13px" }} onClick={() => navigate("/ForgotPassword")}>
                      Forgot Password?
                    </Button>
                  </Box>
                  <Button
                    variant="contained" fullWidth
                    sx={{ backgroundColor: "#007a85", "&:hover": { backgroundColor: "#005f64" }, mb: 2, py: isMobile ? 1 : 1.4, fontSize: isMobile ? "14px" : "15px" }}
                    onClick={handleLogin}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={22} color="inherit" /> : "Sign In"}
                  </Button>
                </>
              )}

              {/* ══════════ OTP MODE ══════════ */}
              {loginMode === "otp" && (
                <>
                  <TextField
                    label="Email or Phone"
                    value={otpIdentifier}
                    onChange={(e) => { setOtpIdentifier(e.target.value); setInlineError(""); }}
                    placeholder="Enter email or 10-digit phone"
                    fullWidth margin="normal"
                    size={isMobile ? "small" : "medium"}
                    disabled={otpSent}
                    onKeyDown={(e) => !otpSent && e.key === "Enter" && handleSendOtp()}
                  />

                  {!otpSent ? (
                    <Button
                      variant="contained" fullWidth
                      sx={{ backgroundColor: "#007a85", "&:hover": { backgroundColor: "#005f64" }, mt: 1, mb: 2, py: isMobile ? 1 : 1.4 }}
                      onClick={handleSendOtp}
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={22} color="inherit" /> : "Send OTP"}
                    </Button>
                  ) : (
                    <>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: "center" }}>
                        OTP sent to your <strong>{otpChannel === "email" ? "email" : "mobile"}</strong>.
                        Enter the 6-digit code below.
                      </Typography>

                      <OtpInput value={otp} onChange={setOtp} disabled={loading} />

                      <Button
                        variant="contained" fullWidth
                        sx={{ backgroundColor: "#007a85", "&:hover": { backgroundColor: "#005f64" }, mb: 1.5, py: isMobile ? 1 : 1.4 }}
                        onClick={handleVerifyOtp}
                        disabled={loading || otp.length < 6}
                      >
                        {loading ? <CircularProgress size={22} color="inherit" /> : "Verify & Sign In"}
                      </Button>

                      {/* Resend countdown */}
                      <Box sx={{ textAlign: "center" }}>
                        {countdown > 0 ? (
                          <Typography variant="body2" color="text.secondary">
                            Resend OTP in <strong>{countdown}s</strong>
                          </Typography>
                        ) : (
                          <Button
                            variant="text" size="small"
                            sx={{ textTransform: "none", color: "#007a85", fontWeight: 600 }}
                            onClick={handleResendOtp}
                            disabled={loading}
                          >
                            Resend OTP
                          </Button>
                        )}
                      </Box>

                      {/* Change identifier */}
                      <Box sx={{ textAlign: "center", mt: 0.5 }}>
                        <Button
                          variant="text" size="small"
                          sx={{ textTransform: "none", fontSize: "12px", color: "text.secondary" }}
                          onClick={() => { setOtpSent(false); setOtp(""); setInlineError(""); }}
                        >
                          ← Change email / phone
                        </Button>
                      </Box>
                    </>
                  )}
                </>
              )}

              {/* ── Sign up link ── */}
              <Typography
                textAlign="center" variant="body2"
                sx={{ mt: loginMode === "otp" && !otpSent ? 0 : undefined }}
              >
                Don't have an account?{" "}
                <a href="/Register" style={{ color: "#007a85", fontWeight: "bold" }}>
                  Sign Up
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Card>

        <CustomDialog
          open={dialog.open}
          title={dialog.title}
          message={dialog.message}
          type={dialog.type}
          onClose={() => setDialog({ ...dialog, open: false })}
        />
      </Box>
      <Footer />
    </>
  );
};

export default Login;